import React from 'react'
import { useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useMobStyles } from './pageHeader.styles'
import { HOME_PATH, ROUTES_BAR } from 'routes/constants.routes'
import { Button, Typography } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { useRoutes } from 'hooks'

const PageHeaderMobile = ({ rightComponent, ...props }) => {
  let location = useLocation()
  const { t } = useTranslation()
  const { goPrevPage } = useRoutes()
  const classes = useMobStyles()
  const name = location.pathname?.replace('/', '')
  const routeKey =
    name &&
    Object.keys(ROUTES_BAR)
      ?.find(key => name?.includes(key?.replace('/', '')))
      ?.replace('/', '')

  return (
    <div className={classes.root}>
      {location.pathname !== HOME_PATH && (
        <>
          <Button className={classes.btnBack} onClick={goPrevPage}>
            <ArrowBackIcon />
            {t('back')}
          </Button>
          <Typography variant={'h5'} className={classes.typography}>
            {t(`pageTitles.${routeKey}`)}
          </Typography>
        </>
      )}
      {!!rightComponent && rightComponent}
    </div>
  )
}
export default PageHeaderMobile
